import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Tab, Tabs } from '@mui/material';

import { SettingLayout } from '@/components/setting/SettingLayout';
import DeviceSubscriptions from '@/components/setting/subscription/DeviceSubscriptions';
import SubscriptionHistory from '@/components/setting/subscription/SubscriptionHistory';

function TabPanel({ index }: { index: number }) {
  const tabs = [DeviceSubscriptions, SubscriptionHistory];
  const SelectedTab = tabs[index];

  return <SelectedTab />;
}

export default function Subscription() {
  const [tabIndex, setTabIndex] = useState(0);
  const { t } = useTranslation();

  return (
    <SettingLayout>
      <Stack sx={{ height: '100%' }}>
        <Tabs value={tabIndex} onChange={(_, i) => setTabIndex(i)}>
          <Tab label={t('Common.label.devices')} sx={{ fontSize: 20, fontWeight: 'bold' }} />
          <Tab label={t('Common.label.history')} sx={{ fontSize: 20, fontWeight: 'bold' }} />
        </Tabs>
        <TabPanel index={tabIndex} />
      </Stack>
    </SettingLayout>
  );
}
